import React from 'react';
import PropTypes from 'prop-types';
import cloneDeep from 'clone-deep';
import deepEqual from 'react-fast-compare';
import {
    isValidNumber,
    isValidTextAndNotEmpty,
    getTextFieldChangedValue,
    roundedValueFixedToTwoDigits,
    isValidFunction,
} from '../../constants/CommonUtil';
import OutlinedTextField from '../OutlinedTextField';
import { isEmpty } from '../../constants/FormValidations';
import {
    getFormFieldValue,
    blurFormField,
    changeFormValue,
} from '../../containers/RegistrationAppComponents/FormUtil';
import { getStringFromObject } from '../../constants/lodashUtils';
import { NumberOf } from '../../constants/numberUtils';
// todo merge with numberTextField later.. it was being used in many places so..
class ReduxFormNumericField extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            validationError: '',
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (
            !deepEqual(nextProps.input, this.props.input) ||
            !deepEqual(nextProps.field, this.props.field) ||
            !deepEqual(nextProps.meta, this.props.meta) ||
            !deepEqual(nextProps.disabled, this.props.disabled) ||
            nextState.validationError !== this.state.validationError
        ) {
            return true;
        }
        return false;
    }

    onBlur = (event) => {
        const {
            name,
            decimalPlaces,
            enablePlusChar,
            stripLeadingZeros,
            onValidationChange,
        } = this.props;

        let changedValue = getFormFieldValue(this.props);

        if (event.target.type === 'number' && changedValue && changedValue.replace && stripLeadingZeros) {
            changedValue = (!isEmpty(changedValue)) ? Number(changedValue) : changedValue;
        }

        if (isValidNumber(decimalPlaces)) {
            changedValue = this.getChangedValueAfterDecimalCorrection(changedValue);
        }

        let validationErrorVal = '';

        this.setState({
            validationError: '',
        });

        // if changed value max, reset to max
        if (changedValue !== '') {
            const { max, min } = this.props;

            if (min && NumberOf(changedValue) < min) {
                validationErrorVal = `Minimum value is ${min}`;

                this.setState({
                    validationError: validationErrorVal,
                });
            }

            if (max && NumberOf(changedValue) > max) {
                validationErrorVal = `Maximum value is ${max}`;

                this.setState({
                    validationError: validationErrorVal,
                });
            }
        }


        this.setState({ validationError: validationErrorVal });

        if (isValidFunction(onValidationChange)) {
            onValidationChange(`${name}.valueNumeric`, validationErrorVal);
        }

        let startsWithPlus = false;
        if (enablePlusChar) {
            if (changedValue.startsWith('+')) {
                startsWithPlus = true;
            }
            changedValue = startsWithPlus ? `+${changedValue}` : changedValue;
        }
        console.log('changed valueee', changedValue);

        const numericChangedValue = changedValue === '' ? '' : NumberOf(changedValue);

        changeFormValue(
            this.props,
            {
                ...event,
                target: {
                    ...event.target,
                    value: startsWithPlus ? changedValue : numericChangedValue,
                },
            },
            startsWithPlus ? changedValue : numericChangedValue,
        );
        const newEvent = cloneDeep(event);
        newEvent.target.value = changedValue;
        blurFormField(this.props, newEvent);
        startsWithPlus = false;
    };

    onChange = (value, event) => {
        console.log('asd-s0adi-asdi-a0as', value);
        changeFormValue(this.props, event, getTextFieldChangedValue(value));
    };

    getChangedValueAfterDecimalCorrection = (value) => {
        const { decimalPlaces } = this.props;

        if (value === '' || value === null || value === undefined || !isValidNumber(decimalPlaces)) {
            return value;
        }

        const number = NumberOf(value);
        return NumberOf(number.toFixed(decimalPlaces));
    };

    handleKeyDown = (event) => {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
        }
    };

    handleWheel = (event) => {
        event.preventDefault();
        if (event.target && event.target.type === 'number' && document.activeElement === event.target) {
            event.target.blur();
        }
    };

    render() {
        console.log('number texxxxxxxxxxxxxt fieldsss', this.props, this.props.min);
        const {
            input,
            field,
            roundValue,
            ...otherProps
        } = this.props;

        const { validationError } = this.state;

        const touched = getStringFromObject('meta.touched', this.props);
        const error = getStringFromObject('meta.error', this.props);

        const customMeta = {
            ...this.props.meta,
            touched: touched || isValidTextAndNotEmpty(validationError),
            error: validationError || error,
        };


        const inputVal = getFormFieldValue(this.props);

        return (
            <OutlinedTextField
                type="number"
                {...otherProps}
                InputLabelProps={{ shrink: true }}
                input={{}}
                value={roundValue ? roundedValueFixedToTwoDigits(inputVal) : inputVal}
                onChange={this.onChange}
                onKeyDown={this.handleKeyDown}
                onBlur={this.onBlur}
                errorText={validationError || (touched && error ? error : '')}
                meta={customMeta}
                onWheel={this.handleWheel}
            />
        );
    }
}

ReduxFormNumericField.propTypes = {
    name: PropTypes.string,
    input: PropTypes.object,
    // for formik
    field: PropTypes.object,
    meta: PropTypes.object,
    roundValue: PropTypes.bool,
    max: PropTypes.any,
    min: PropTypes.any,
    decimalPlaces: PropTypes.number,
    stripLeadingZeros: PropTypes.bool,
    disabled: PropTypes.bool,
    enablePlusChar: PropTypes.bool,
    onValidationChange: PropTypes.func,
};

ReduxFormNumericField.defaultProps = {
    name: '',
    input: {},
    field: {},
    roundValue: false,
    meta: {
        touched: false,
        error: '',
    },
    max: 99999999999999999999,
    min: 0,
    decimalPlaces: null,
    stripLeadingZeros: true,
    disabled: false,
    enablePlusChar: false,
    onValidationChange: () => {},
};

export default ReduxFormNumericField;
